import HTTPClient from "./http-client";
import REGIONAL_IDS from "@/utils/regionalIds";


class DailyForecastService {
  async getRegionalForecast(id, date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(`/alertadis/daily34forecasts?regionalIds=${id || REGIONAL_IDS}&date=${date}`);
  }
  async getRegionalForecastHourly(id, date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `/alertadis/hourly34forecasts?regionalIds=${id || REGIONAL_IDS}&datetime=${date}`
    );
  }
  async getAgencyForecast(id, date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(`/alertadis/daily34forecasts?agencyIds=${id}&date=${date}`);
  }
  async getAgencyForecastHourly(id, date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `/alertadis/hourly34forecasts?agencyIds=${id}&datetime=${date}`
    );
  }
  async getCountieForecast(id, date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(`/alertadis/daily34forecasts?locationIds=${id}&date=${date}`);
  }
  async getCountieForecastHourly(id, date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `/alertadis/hourly34forecasts?locationIds=${id}&datetime=${date}`
    );
  }
  async getCountieForecastAll(id) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(`/alertadis/daily34forecasts?locationIds=${id}`);
  }
  async getCountieClassInterruptionAll(id) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(`/cityclassinterruption?locationIds=${id}`);
  }
  async getCountieForecastHourlyAll(id) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(`/alertadis/hourly34forecasts?locationIds=${id}`);
  }
  async getRegionalForecastOverview(date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `/alertadis/sumstartdailyregionalinterruption?regionalIds=${REGIONAL_IDS}&date=${date}`
    );
  }
  async getRegionalForecastHourlyOverview(date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `/alertadis/sumstartregionalhourlyinterruption?regionalIds=${REGIONAL_IDS}&datetime=${date}`
    );
  }
  async getRegionalForecastHourlyGraphic(date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `/alertadis/sumstarthourly34interruption?regionalIds=${REGIONAL_IDS}&datetime=${date}`
    );
  }
  async getRegionalForecastDailyGraphic(date) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `/alertadis/sumstartdailyinterruption?regionalIds=${REGIONAL_IDS}&date=${date}`
    );
  }
  async getCountiesForecastDetailsTable(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/daily34forecasts`, payload, headers);
  }
  async getCountiesForecastHourlyDetailsTable(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/hourly34forecasts`, payload, headers);
  }
  async getDailyInterruptionsForNotifications(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/daily34interruptions`, payload, headers);
  }

  async getHourly34RegionalSumInterruptions(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/hourly34regionalsuminterruptions`, payload, headers);
  }

  async getlastruntimeforecastDaily() {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `lastruntimeforecast?periodType=daily&sourceId=29&locationId=4118907`
    );
  }
  async getlastruntimeforecastHourly() {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `lastruntimeforecast?periodType=hourly&sourceId=29&locationId=4106902`
    );
  }
}

export default new DailyForecastService();
